import React from 'react'
import Navbar from './Navbar'
import BlogPage_c1 from './Blog_c1'
import { useEffect, useState } from 'react';

import PlacementNews from './Placement';
import Footer from './Footer';
function Full_blog() {
    const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
  
  const [showScrollTop, setShowScrollTop] = useState(false);
      
        useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  return (
    <div>
        <Navbar onEnrollClick={() => setShowForm(true)} /><br></br><br></br><br></br>
        <BlogPage_c1/>
        
        {/* <PlacementNews/> */}
        <Footer/>

          <a
        href="https://wa.me/9944897638"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Scroll to Top Icon */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}
    </div>
  )
}

export default Full_blog